<template>
  <div class="home-detail-container">
    <div class="home-detail">
      <Breadcrumb :breadcrumbName="breadcrumbObj"></Breadcrumb>
      <!-- <el-row>
        <el-col style="width:20px;floart:left;margin-top: 7px;">
          <img src="../../../assets/public/position.png" />
        </el-col>
        <el-col class="home-detail-breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>企业详情</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row> -->
      <el-row class="detail-header">
        <el-col :span="12">
          <el-row style="margin-top:10px;">
            <el-col :span="24">
              <span class="detail-company">{{baseInfo.name}}</span>
            </el-col>
            <el-col
              :span="20"
              style="margin-top:10px;"
            >
              <div style="height:60px;line-height:30px;">
                <el-col :span="4">
                  <span style="font-size:14px;color:gray;">企业所在地:</span>
                </el-col>
                <el-col :span="16">
                  <span style="font-size:14px;width:300px;">{{baseInfo.completeaddress}}</span>
                </el-col>
                <!--                 <el-col :span="4">-->
                <!--                  <div @click="clickAttention(true)" v-if="!isAttention" class="attention-wrap">-->
                <!--                    <img src="../../../assets/attention0.png" height="14" width="15"/>-->
                <!--                    <span>关注</span>-->
                <!--                  </div>-->
                <!--                  <div @click="clickAttention(false)" v-else class="attention-wrap">-->
                <!--                    <img src="../../../assets/attention1.png" height="14" width="16"/>-->
                <!--                    <span>已关注</span>-->
                <!--                  </div>-->
                <!--                </el-col>-->
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row style="height:56px;">
            <el-col
              :span="4"
              class="hr-phone-img"
            >
              <img src="../../../assets/public/dianhua.png" />
            </el-col>
            <el-col
              :span="7"
              class="hr-phone"
            >
              <p class="header-tel-phone">{{simplePhone}}</p>
              <p
                class="header-tel-phone"
                style="margin-top:20px;"
              >400-001-0051</p>
            </el-col>
            <el-col
              :span="7"
              class="hr-phone"
              style="text-align:left;"
            >
              <p class="header-tel-text">联系人</p>
              <p
                class="header-tel-text"
                style="margin-top:20px;"
              >客服联系电话</p>
            </el-col>
            <el-col :span="6">
              <el-button
                type="text"
                style="background:#F7AB01;color:white;padding-left:20px;padding-right:20px;"
                v-if="$store.state.loginType"
                @click="showPhone"
              >查看联系方式</el-button>
              <el-button
                type="text"
                style="background:#F7AB01;color:white;padding-left:20px;padding-right:20px;"
                v-else
                @click="loginIndex"
              >查看联系方式</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="4"
              style="height:1px;"
            >
            </el-col>
            <el-col :span="20">
              <span style="color:#969696;font-size:12px;">联系时，请说是在施工邦看到的哦！</span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div style="width:100%;height:10px;"></div>
      <el-row class="detail-right-tabs">
        <el-tabs
          v-model="activeTab"
          type="card"
          @tab-click="handleClick"
        >
          <el-tab-pane
            label="企业信息"
            name="first"
          ></el-tab-pane>
          <el-tab-pane
            :label="gcyjLabel"
            name="second"
          ></el-tab-pane>
          <el-tab-pane
            :label="barcLabel"
            name="third"
          ></el-tab-pane>
        </el-tabs>
      </el-row>
      <el-row
        class="company-detail-content"
        v-if="activeTab == 'first'"
      >
        <el-col :span="24">
          <el-row>
            <company-info
              :data="baseInfo"
              :remarks="remarks"
              :qualify="zzlist"
              :address="companyAddress"
              v-if="activeTab == 'first'"
            ></company-info>
            <performance-list
              :data="gcyjRecord"
              :total="gcyjTotal"
              @gcyjChange="gcyjChange"
              v-if="activeTab == 'second'"
            ></performance-list>
            <talents
              :data="barcRecord"
              :total="barcTotal"
              @barcChange="barcChange"
              v-if="activeTab == 'third'"
            ></talents>
          </el-row>
        </el-col>
      </el-row>
      <el-row v-if="activeTab != 'first'">
        <el-col :span="24">
          <el-row>
            <performance-list
              :data="gcyjRecord"
              :total="gcyjTotal"
              @gcyjChange="gcyjChange"
              v-if="activeTab == 'second'"
            ></performance-list>
            <talents
              :data="barcRecord"
              :total="barcTotal"
              @barcChange="barcChange"
              v-if="activeTab == 'third'"
            ></talents>
          </el-row>
        </el-col>
      </el-row>
      <div
        class="tc-50"
        v-if="activeTab == 'first'"
      ></div>
      <!-- <div style="width:100%;height:20px;"></div> -->
    </div>
  </div>

</template>

<script>
// import { apiHome } from '@/api/apiHome'
import { BuildingPower } from '@/api/apiBuildingPower'
import apiHelp from '@/api/apiHelp'
import cookie from '@/storage/cookies'

// import link from '@/public/link.js'
export default {
  data () {
    return {
      breadcrumbObj: {
        fristName: '首页',
        fristPath: '/',
        secondName: '建设力量',
        secondPath: '/buildPower',
        threeName: '详情'
      },
      baseInfo: {},
      zzlist: [],
      gcyjRecord: [],
      gcyjPage: 1,
      gcyjLimit: 20,
      gcyjTotal: 0,
      barcRecord: [],
      barcPage: 1,
      barcLimit: 20,
      barcTotal: 0,
      remarks: [],
      pname: this.$route.query.pname,
      cname: this.$route.query.cname,
      tname: this.$route.query.tname,
      companyAddress: '',
      activeTab: 'first',
      gcyjLabel: '工程业绩',
      barcLabel: '备案人才',
      simplePhone: '',
      isAttention: false,
      isRepeatSubmit: false
    }
  },
  components: {
    Breadcrumb: () => import('@/components/public/RedesignBreadcrumb'),
    Talents: () =>
      import('@/views/RedesignTeamList/buildComponent/components/Talents')
  },
  computed: {
    isLogin: function () {
      return this.$store.state.token
    }
  },
  methods: {
    async initBaseInfo () {
      let result = await BuildingPower.getCompanyDetail({
        no: this.$route.query.no
      })
      this.baseInfo = result.data.result
      this.companyAddress =
        this.cname + this.tname + result.data.result.detailAddr
      let t = result.data.result
      this.simplePhone = t.phone.substr(0, 3) + '****' + t.phone.substr(7)
    },
    async getZzList () {
      let result = await BuildingPower.getZzList({
        companyNo: this.$route.query.no
      })
      this.zzlist = result.data.result
    },
    async initGcyj () {
      let result = await BuildingPower.getGcyjPages({
        companyNo: this.$route.query.no,
        page: this.gcyjPage,
        limit: this.gcyjLimit
      })
      if (result.data.result !== null) {
        this.gcyjRecord = result.data.result.content
        this.gcyjTotal = result.data.result.totalElements
        this.gcyjLabel =
          '工程业绩' + '(' + result.data.result.totalElements + ')'
      }
    },
    async initBarc () {
      let result = await BuildingPower.getBarcPages({
        enterNo: this.$route.query.no,
        page: this.barcPage,
        limit: this.barcLimit
      })
      if (result.data.result !== null) {
        this.barcRecord = result.data.result.content
        this.barcTotal = result.data.result.totalElements
        this.barcLabel =
          '备案人才' + '(' + result.data.result.totalElements + ')'
      }
    },
    loginIndex () {
      const h = this.$createElement
      this.$msgbox({
        title: '消息',
        message: h('p', null, [
          h('span', null, '查看联系方式需要登录哦, 确认登录吗？ ')
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        callback: res => {
          if (res === 'confirm') {
            let data = {
              callBack: function () {
                this.$store.dispatch('setUser')
              }.bind(this)
            }
            this.$_login(data)
          }
        }
        // beforeClose: (action, instance, done) => {}
      }).then(action => {
        // this.$message({
        //   type: 'info',
        //   message: 'action: ' + action
        // })
      })
    },
    showPhone () {
      this.simplePhone = this.baseInfo.phone
    },

    async getRemarks () {
      let result = await BuildingPower.getRemarks({
        cno: this.$route.query.no
      })
      this.remarks = result.data.result
    },
    gcyjChange (val) {
      this.gcyjPage = val
      this.initGcyj()
    },
    barcChange (val) {
      this.barcPage = val
      this.initBarc()
    },
    handleClick () {
      //
    },
    // 获取是否关注
    userFocus () {
      let params = {
        no: this.$route.query.no,
        type: 9
      }
      apiHelp.userFocus(params).then(res => {
        if (res.data && res.data.code === 200) {
          this.isAttention = res.data.data
        }
      })
    },
    // 点击关注
    clickAttention (state) {
      let token = this.$store.state.token
      if (!token) {
        let data = {
          callBack: function () {
            this.$store.dispatch('setUser')
          }.bind(this)
        }
        this.$_login(data)
      } else {
        let params = {
          businessNo: this.$route.query.no,
          type: 9
        }
        if (this.isRepeatSubmit) return
        this.isRepeatSubmit = true
        apiHelp.attentionHandle(params).then(res => {
          if (res.data && res.data.code === 200) {
            this.isAttention = state
            if (state) {
              this.$message.success('关注成功')
            } else {
              this.$message.success('取消关注成功')
            }
          }
        }).finally(() => {
          this.isRepeatSubmit = false
        })
      }
    }

  },
  mounted () {
    this.initBaseInfo()
    this.getRemarks()
    this.getZzList()
    this.initGcyj()
    this.initBarc()
    if (cookie.cookieRead('token')) {
      this.userFocus()
    }
  },
  watch: {
    activeTab () {
      this.$nextTick(() => {
        this.initBaseInfo()
      })
    },
    isLogin: {
      handler: function (newVal, oldVal) {
        newVal && this.userFocus()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .attention-wrap{
    cursor: pointer;
    img{
      position: relative;
      top: 3px;
      margin-right: 10px;
    }
    span{
      font-size: 14px;
    }
  }
.home-detail-container {
  background: #f5f5f5;
}
.home-detail {
  width: 1200px;
  margin: 0 auto;
  min-height: 420px;
}
.home-detail-breadcrumb {
  width: 1180px;
  float: left;
  margin-top: 10px;
}
.detail-company {
  line-height: 23px;
  width: 286px;
  height: 23px;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}
.detail-header {
  padding: 20px;
  // height: 125px;
  margin-top: 10px;
  background: white;
  border: 1px solid #e4e7ed;
}
.detail-map-introduce {
  margin-top: 60px;
  padding-top: 50px;
  width: 90%;
  margin-left: 5px;
  height: 420px;
  border: 1px solid rgba(154, 154, 154, 0.2);
  font-size: 14px;
}
.detail-left-row {
  margin-bottom: 20px;
}
.detail-left-label {
  text-align: right;
}
.detail-left-text {
  padding-left: 10px;
  padding-right: 10px;
}
.detail-right-tabs {
  // background: white;
  // padding-bottom: 10px;
  // border-left: 1px solid #E4E7ED;
  // border-right: 1px solid #E4E7ED;
  // border-bottom: 0px;
}
.bgtabs {
  background: #409eff !important;
  color: white !important;
}
.hr-phone-img {
  text-align: center;
  height: 80px;
  padding-left: 19px;
  padding-top: 10px;
  //margin-left: 10px;
  // line-height: 100px;
}
.hr-phone {
  text-align: left;
  height: 40px;
  // line-height: 40px;
}
.header-tel-phone {
  color: #ff6600;
  font-size: 18px;
  height: 13px;
  font-weight: bold;
}
.header-tel-text {
  font-size: 16px;
  height: 13px;
  font-weight: 400;
  color: #666;
  // font-weight: bolder;
}
.company-detail-content {
  background: white;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  border: 1px solid #e4e7ed;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
  border-radius: 0px 0px 4px 4px;
  padding-bottom: 50px;
  border-top: 0px;
}
/deep/ .el-tabs__nav {
  background: white;
}
</style>
<style>
.el-breadcrumb::before {
  background-image: url("../../../assets/public/position.png");
}
.el-tabs__item.is-active {
  color: #0286df;
}
.el-tag {
  border: 1px solid #e4e7ed !important;
}
.el-tabs__header {
  margin: 0px !important;
}
.el-tabs--card > .el-tabs__header .el-tabs__item {
  border-bottom: 1px solid #e4e7ed;
}
</style>
